var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgRs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7303_39092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37262 0 0 5.37262 0 12C0 13.4678 0.264047 14.874 0.746391 16.1739H23.2537C23.736 14.874 24 13.4678 24 12C24 5.37262 18.6274 0 12 0Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 0C6.84061 0 2.4421 3.2565 0.746582 7.82611H23.2538C21.5583 3.2565 17.1598 0 12.0002 0V0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10303 6.78262V12.7688C3.10303 16.174 7.55151 17.2174 7.55151 17.2174C7.55151 17.2174 11.9999 16.174 11.9999 12.7688V6.78262H3.10303Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94287 7.8261H10.1603V5.73913L9.11681 6.26085L7.55161 4.69565L5.98636 6.26085L4.94287 5.73913V7.8261Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9565 13.6023L7.56514 10.211L4.17383 13.6023L5.28059 14.7091L7.56514 12.4245L9.84969 14.7091L10.9565 13.6023Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9565 10.4348H9.37414C9.46311 10.2812 9.51486 10.1034 9.51486 9.91317C9.51486 9.3368 9.04766 8.86969 8.47137 8.86969C8.07317 8.86969 7.72737 9.09272 7.55145 9.42061C7.37553 9.09277 7.02973 8.86969 6.63153 8.86969C6.05525 8.86969 5.58805 9.3368 5.58805 9.91317C5.58805 10.1034 5.6398 10.2813 5.72877 10.4348H4.17383C4.17383 11.0111 4.67581 11.4783 5.25205 11.4783H5.21731C5.21731 12.0546 5.68447 12.5218 6.2608 12.5218C6.2608 13.032 6.62727 13.456 7.11125 13.5467L6.28906 15.4031C6.68309 15.5633 7.11369 15.6522 7.56519 15.6522C8.01669 15.6522 8.44728 15.5633 8.84131 15.4031L8.01913 13.5467C8.50311 13.4561 8.86958 13.0321 8.86958 12.5218C9.44591 12.5218 9.91306 12.0546 9.91306 11.4783H9.87833C10.4545 11.4783 10.9565 11.0111 10.9565 10.4348V10.4348Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7303_39092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRs);
export default __webpack_public_path__ + "static/media/rs.5b3f04923f48a7b9bc189922eeb9cc6e.svg";
export { ForwardRef as ReactComponent };